import React from 'react';

import {
  SelectInput,
} from 'react-admin';

import StatusField from './StatusField';
import EditFieldLayout from '../components/layout/EditFieldLayout';

const EditStatus = ({
  source,
  label,
  showEdit,
}: {
  source: string;
  label: string;
  showEdit: boolean;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    inputElement={(
      <SelectInput
        source="status"
        choices={[
          { id: 'Blocked', name: 'Blocked' },
          { id: 'Available', name: 'Available' },
        ]}
        label={false}
        helperText={false}
      />
    )}
    fieldElement={(
      <StatusField source={source} />
    )}
  />
);

export default EditStatus;
